import { useQuery } from "@tanstack/react-query"

import { api } from "@/api"
import ENDPOINTS from "@/constants/endpoints"

export type SmartRoutingConfigurationDetail = {
  id: string
  whiteLabelId: string
  paymentMethod: string
  period: "DAILY" | "WEEKLY" | "MONTHLY" | "YEARLY"
  status: "ACTIVE" | "INACTIVE"
  firstProcessor: {
    processor: {
      id: string
      whiteLabelId: string
      paymentMethod: string
      processorId: string
      processor: {
        id: string
        name: string
      }
      createdAt: string
      updatedAt: string
    }
    target: number
    routingByTarget: boolean
  }
  secondProcessor?: {
    processor: {
      id: string
      whiteLabelId: string
      paymentMethod: string
      processorId: string
      processor: {
        id: string
        name: string
      }
      createdAt: string
      updatedAt: string
    }
    target: number
    routingByTarget: boolean
  }
  rules?: {
    field: string
    operator: string
    value: string
    connector?: "AND" | "OR"
  }[]
  createdAt: string
  updatedAt: string
}

export const useSmartRoutingConfiguration = (
  uuid?: string
) => {
  return useQuery({
    queryKey: ["smart-routing-configuration", uuid],
    queryFn: async () => {
      if (!uuid) return null

      const { data } =
        await api.get<SmartRoutingConfigurationDetail>(
          `${ENDPOINTS.SMART_ROUTING_CONFIGURATIONS}/${uuid}`
        )
      return data
    },
    enabled: !!uuid,
  })
}
